var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWorkflowActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM16.41 9.83C15.8 11.57 14.16 12.74 12.32 12.74C12.31 12.74 12.31 12.74 12.3 12.74L10.24 12.73C10.24 12.73 10.24 12.73 10.23 12.73C9.47 12.73 8.81 13.24 8.61 13.97C9.5 14.25 10.15 15.08 10.15 16.06C10.15 17.27 9.16 18.26 7.95 18.26C6.74 18.26 5.75 17.27 5.75 16.06C5.75 15.17 6.29 14.4 7.05 14.06V9.7C6.29 9.4 5.75 8.66 5.75 7.8C5.75 6.67 6.67 5.75 7.8 5.75C8.93 5.75 9.85 6.67 9.85 7.8C9.85 8.67 9.31 9.4 8.55 9.7V11.72C9.04 11.41 9.62 11.23 10.23 11.23H10.24L12.3 11.24C13.48 11.28 14.53 10.52 14.95 9.42C14.46 9.04 14.14 8.46 14.14 7.8C14.14 6.67 15.06 5.75 16.19 5.75C17.32 5.75 18.24 6.67 18.24 7.8C18.25 8.86 17.44 9.72 16.41 9.83Z",
    fill: "#54BD95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkflowActive);
export default __webpack_public_path__ + "static/media/icon_workflow_active.bf85a17df108ad1f05a786483bc95b81.svg";
export { ForwardRef as ReactComponent };